import React from 'react';
import SkeletonLoadingBox from '../common/SkeletonLoadingBox';

function ProductListItemSkeleton(props) {
    return (
        <div className='product-grid__item'>
            <div className='product-grid__link'>
                <figure className='photo product-grid__photo'>
                    <SkeletonLoadingBox
                        width='100%'
                        style={{ paddingBottom: '100%' }}
                    />
                </figure>
                <div className='product-grid__content'>
                    <span className='product-grid__heading'>
                        <SkeletonLoadingBox width={70} height={16} />
                    </span>
                    <span className='product-grid__title'>
                        <SkeletonLoadingBox width={130} height={24} />
                    </span>
                </div>
                <div className='product-grid__label-wrapper' />
                <div className='product-grid__price-wrapper'>
                    <span className='product-grid__price'>
                        <SkeletonLoadingBox width={50} height={18} />
                    </span>
                </div>
                <div className='product-grid__action-wrapper'>
                    <SkeletonLoadingBox width={131.34} height={47.38} />
                </div>
            </div>
        </div>
    );
}

export default ProductListItemSkeleton;
